import { __rest } from "tslib";
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
const labelVariants = cva("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
/**
 * @example
 *
 * ```jsx
 * import { Checkbox, Label } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <div>
 *       <div className="flex items-center space-x-2">
 *         <Checkbox id="terms" />
 *         <Label htmlFor="terms">Accept terms and conditions</Label>
 *       </div>
 *     </div>
 *   )
 * }
 * ```
 */
const Label = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(LabelPrimitive.Root, Object.assign({ ref: ref, className: cn(labelVariants(), className) }, props)));
});
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };
//# sourceMappingURL=label.js.map